import { Pivot, PivotItem, Stack } from '@fluentui/react';
import { useIdentityPanelState } from 'features/IdentityPanel/IdentityPanel.state';
import IvicosStrings from 'kits/language/stringKit';
import React from 'react';
import { useWindowWidth } from 'shared-state/display-options/hooks';
import CommunicationSettings from './children/CommunicationSettings/CommunicationSettings';
import DashboardWidgets from './children/DashboardWidgets/DashboardWidgets';
import PersonalPreferences from './children/PersonalPreferences/PersonalPreferences';
import UserProfile from './children/UserProfile/UserProfile';
import IdentityPanelView from './IdentityPanel.view';

const IdentityPanel: React.FC<{}> = () => {
    const state = useIdentityPanelState();
    const { smallDevice } = useWindowWidth();

    return (
        <IdentityPanelView {...state}>
            {/* Visitors get neither the tabs nor personal preferences/widgets — same as before,
                so they still just see the (disabled-edit) profile view on its own. */}
            {state.visitorCheck.isVisitor ? (
                <UserProfile />
            ) : (
                <>
                    <Pivot selectedKey={state.selectedKey} onLinkClick={state.handleLinkClick} headersOnly={true}>
                        <PivotItem headerText={IvicosStrings.profileTabTitle} itemKey="profile" />
                        <PivotItem headerText={IvicosStrings.widgetsTabTitle} itemKey="widgets" />
                        <PivotItem headerText={IvicosStrings.preferencesTabTitle} itemKey="preferences" />
                    </Pivot>
                    <Stack
                        style={{
                            // Leaves room for the Panel header + tabs above, and the absolutely-positioned
                            // sign-out button below, rather than an arbitrary small percentage that clipped
                            // content once UserProfile moved in here (bug: dead space below a tiny 40vh
                            // scroll box even though the Panel itself has plenty of height).
                            maxHeight: smallDevice ? 'calc(100vh - 260px)' : 'calc(100vh - 220px)',
                            overflowY: 'auto',
                            paddingBottom: '20px'
                        }}
                    >
                        {state.selectedKey === 'profile' && (
                            <>
                                <UserProfile />
                                <PersonalPreferences />
                            </>
                        )}
                        {state.selectedKey === 'widgets' && (
                            <DashboardWidgets
                                draftHiddenWidgets={state.draftHiddenWidgets}
                                onToggleWidget={state.onToggleWidget}
                                isSaving={state.isSaving}
                                isDirty={state.isDirty}
                                onSave={state.onSaveWidgets}
                            />
                        )}
                        {state.selectedKey === 'preferences' && <CommunicationSettings />}
                    </Stack>
                </>
            )}
        </IdentityPanelView>
    );
};

export default IdentityPanel;
